/*
 * Copyright (c) 2019 - Indigen Solutions
 * Authors:
 *   - Bichoy Messiha <bm@indigen.com>
 * NOTICE: All information contained herein is, and remains
 * the property of Indigen Solutions and its suppliers,
 * if any.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */

import { concat, slice, sortBy } from "lodash";
import MiniSearch from "minisearch";
import { BaseSearch } from "./BaseSearch";
import { Services } from "./Services";

export class SearchPublicService extends BaseSearch {
    async init() {
        const { conventions, updatedAt } = await Services.api.convention.getPublicSearchable();
        this.conventions = conventions;
        const searchOptions = {
            prefix: true,
            combineWith: "AND",
        };

        this.initEngine(
            "conventionsEngine",
            {
                fields: ["title", "brochure", "idcc"],
                storeFields: [
                    "conventionId",
                    "variantNumber",
                    "parentConventionId",
                    "brochure",
                    "title",
                    "idcc",
                ],
                processTerm: term => (term.length < 4 ? null : this.clean(term)),
                searchOptions,
            },
            this.conventions,
            updatedAt
        );
    }

    getAllConventions() {
        return this.conventions.filter(ccn => ccn.parentConventionId == null);
    }

    /**
     * Suggestions
     * @param query
     */
    getSuggestions(query) {
        if (!query) return [];
        query = this.clean(query);

        let suggestions = [];
        if (query.match(/\d{1,5}.{1,3}/)) {
            const brochureSuggestions = slice(this.getSuggestionsBrochures(query), 0, 3);
            const idccSuggestions = slice(this.getSuggestionsIdcc(query), 0, 3);
            suggestions = sortBy(concat(brochureSuggestions, idccSuggestions), s => s.score);
        }
        return suggestions;
    }

    /* . */

    /**
     * Search results by text
     * @param query
     * @override
     */
    searchConventionsText(query, territory) {
        if (query.length < 3 || !this.conventionsEngine) return [];
        query = this.clean(query);
        const results = this.conventionsEngine.search(query, {
            fuzzy: 0.25,
            boost: { title: 100 },
        });
        return this.manageResults(results, territory, 0);
    }

    /**
     *
     * @param results
     * @override
     */
    manageResults(results, territory, scoreLimit) {
        const conventions = this.getConventionsFromResults(results, scoreLimit);
        return territory ? this.filterTerritory(conventions, territory) : conventions;
    }

    /**
     *
     * @param name
     * @param options
     * @param documents
     */
    initEngine(name, options, documents, updateAt) {
        const localStorageName = `public-${name}`;
        const storedUpdatedAt = localStorage.getItem("publicConventionSearchablesUpdatedAt");
        const isUpToDate =
            storedUpdatedAt && updateAt && Services.moment(storedUpdatedAt).isSameOrAfter(updateAt);

        const engine = localStorage.getItem(localStorageName);
        if (engine && isUpToDate) {
            this[name] = MiniSearch.loadJSON(engine, options);
        } else {
            this[name] = new MiniSearch(options);
            this[name].addAll(documents);
            localStorage.setItem(localStorageName, JSON.stringify(this[name].toJSON()));
        }
        localStorage.setItem("publicConventionSearchablesUpdatedAt", updateAt);
    }
}
